import { createContext } from "react";

const TribesDataContext = createContext();

export default TribesDataContext;
